<template>
    <div v-if="types===1 || types===2" class="more" @click="gotoPage(types)">
        {{types===1?'更多职位':'更多公司'}}
        <i class="el-icon-arrow-right"></i>
    </div>
    <div v-else class="more" @click="gotoPage(3)">查看更多 <i class="el-icon-arrow-right"></i></div>

</template>
  
  <script>

  export default {
    props: {
      types:{
        type:Number,
        default:null
      },
      id:{
        type:Number,
        default:null
      }
    },
    components: {
     
    },
    methods:{
        gotoPage(type){
          let obj={
            3:`/job`,
            1:`/company/detail?id=${this.id}`,
            2:`/company`,
          }
          console.log(type,obj[type],8989898989)
          this.$router.push({
            path:obj[type],
            // query: this.id ? id=this.id :''
          });
           
        },
    }
  };
  </script>
  
  <style lang="scss">
    .more{
        width: 126px;
        height: 40px;
        line-height: 38px;
        border-radius: 6px;
        border: 1px solid #287CF3;
        color: #287CF3;
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #659DF7;
        margin: 0 auto;
        cursor: pointer;
        transition: all .2s linear;
        &:hover{
          background: rgba(40,124,243,0.1);
        }
        i{
            font-size: 14px;
            font-weight: 500;
            color: #659DF7;
        }
    }
  </style>
  